import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, TouchableOpacity } from 'react-native';

import { WebModal } from '@components/Modals/WebModal.web';
import { Box, Text } from '@components/Restyle';
import theme from '@themes/theme';

interface DeleteFilesModalProps {
  showModal: boolean;
  onClose: () => void;
  onConfirm: () => void;
  fileCount: number;
}

export const DeleteFilesModal: React.FC<DeleteFilesModalProps> = ({
  showModal,
  onClose,
  onConfirm,
  fileCount,
}) => {
  const { t } = useTranslation('models');

  const handleConfirm = () => {
    onClose();
    onConfirm();
  };

  return (
    <WebModal
      accessibilityLabel='Delete Files Modal'
      title={t('models:files.deletePopup.title')}
      onClose={onClose}
      visible={showModal}
      width={483}
      height={184}>
      <>
        <Text variant='bodySecondary' marginHorizontal='m' marginVertical='l'>
          {t('models:files.newDeleteProjectFiles', {
            count: fileCount,
          })}
        </Text>
        <Box
          flexDirection='row'
          alignItems='flex-end'
          mx='m'
          mb='l'
          alignSelf='flex-end'>
          <TouchableOpacity onPress={handleConfirm} style={styles.deleteButton}>
            <Text variant='bodyTaskName' color='white'>
              {t('models:deleteTask.title')}
            </Text>
          </TouchableOpacity>
        </Box>
      </>
    </WebModal>
  );
};

const styles = StyleSheet.create({
  deleteButton: {
    backgroundColor: theme.colors.black,
    paddingHorizontal: 40,
    paddingVertical: theme.spacing.m,
    borderRadius: theme.borderRadii.xs,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
